// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var itemContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("spaceEvenly"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(1000)),
      BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(125)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(32)),
      BsCssJs$PrezzeeRibbon.hover([
            BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.activeBluePaleBg),
            BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.activeBlue)]),
            BsCssJs$PrezzeeRibbon.cursor("pointer")
          ])
    ]);

var title = BsCssJs$PrezzeeRibbon.style([
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.fontWeight({
            NAME: "num",
            VAL: 400
          }),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(3))
    ]);

var blueContainer = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.activeBluePaleBg)]);

var grayContainer = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.paleGrey)]);

var activeBlueTheme = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.activeBlue)]);

var darkTheme = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.darkGrey)]);

var Styles = {
  itemContainer: itemContainer,
  title: title,
  blueContainer: blueContainer,
  grayContainer: grayContainer,
  activeBlueTheme: activeBlueTheme,
  darkTheme: darkTheme
};

function Auth__SignedInMenuItem(props) {
  var activeState = props.activeState;
  var colourContainerClass = activeState ? blueContainer : grayContainer;
  var iconTextColour = activeState ? activeBlueTheme : darkTheme;
  var itemContainer$1 = Classnames([
        itemContainer,
        colourContainerClass
      ]);
  var titleClass = Classnames([
        title,
        iconTextColour
      ]);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.icon,
                      className: iconTextColour
                    }),
                JsxRuntime.jsx("div", {
                      children: props.title,
                      className: titleClass
                    })
              ],
              className: itemContainer$1
            });
}

var make = Auth__SignedInMenuItem;

export {
  Styles ,
  make ,
}
/* itemContainer Not a pure module */
